import { styledSafe } from "src/utils/styledComponent";
import { Flex } from "../Box/Box";
import { Track } from "./components/Track";
import { Handle } from "./components/Handle";
import { Text } from "../Text/Text";
import { InfoTooltip } from "../InfoTooltip/InfoTooltip";
import { Color } from "../Color/Color";

const RangeInput = styledSafe("input")`
  width: 100%;
  margin: 0;
  opacity: 0;
  cursor: grab;

  :active {
    cursor: grabbing;
  }
`;

interface Props {
  min: number;
  max: number;
  step: number;
  value: number;
  setValue: (value: number) => void;
  valueLabel?: string | number;
  title?: string;
  tooltip?: string;
  leftLabel?: string;
  rightLabel?: string;
  isDisabled?: boolean;
}

export const Range = ({
  min,
  max,
  step,
  value,
  setValue,
  valueLabel,
  leftLabel,
  rightLabel,
  title,
  tooltip,
  isDisabled,
}: Props) => {
  const percentage = (value * 100) / max;

  return (
    <Flex column width="100%" pointerEvents={isDisabled ? "none" : "auto"}>
      <Flex justify="between" align="center">
        {title && <Text variant="body1">{title}</Text>}
        {tooltip && <InfoTooltip tooltip={tooltip} />}
      </Flex>

      <Flex width="100%" position="relative" margin="20px 2px 1px 2px">
        <Track percentage={percentage} isDisabled={isDisabled} />
        <Handle percentage={percentage} value={valueLabel || value} isDisabled={isDisabled} />

        <RangeInput
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(event) => setValue(Number(event.target.value))}
        />
      </Flex>

      <Flex justify="between">
        <Text variant="small2" color={isDisabled ? Color.textDisabled : undefined}>
          {leftLabel}
        </Text>
        <Text variant="small2" color={isDisabled ? Color.textDisabled : undefined}>
          {rightLabel}
        </Text>
      </Flex>
    </Flex>
  );
};
